import * as R from 'ramda'

//noinspection JSUnusedGlobalSymbols
export default {

    all: state => Object.values(state.entities),

    byId: state => id => {
        return state.entities[id]
    },

    allByProductId: (state, getters) => (productId, withArchived = false) => {
        return R.compose(

            // Nach `productId` filter
            // > [ { id: 1, product: 2 }, { id: 3, product: 4 } ]
            // < [ { id: 1, product: 2 } ]
            R.filter(R.propEq('product', productId)),


            // Wenn `withArchived`, dann alle Jobs berücksichtigen
            // ansonsten nur die, die nicht archiviert sind
            // > false
            // < [ { id: 1, product: 2 }, { id: 3, product: 4 } ]
            R.ifElse(R.equals(false),
                () => getters['all'],
                () => getters['allByIsArchived'](false)
            )

        )(withArchived)
    },

    allByIsArchived: (state, getters) => isArchived => {
        return R.filter(R.propEq('isArchived', isArchived), getters['all'])
    },

    counts: state => state.counts,

}


